import { RootState } from '..'
import { IState } from './type'

export const selectArtist = (state: RootState): IState => state.artist
